import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { AUFlagIcons, CloseDialogIcon } from "assets/styles/icons";
import DialogMultipleLoans from "components/apply-loan/DialogMultipleLoans";
import DialogBrokerApplications from "components/brokers/DialogBrokerApplications";
import {
  getApplicationStatus,
  getLoanTypeName,
  getLoanTypeValue,
  useProgress,
} from "context/ProgressProvider";
import dayjs from "dayjs";
import { Formik } from "formik";
import { useIsMobile } from "pages/landing";
import { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { DefaultPagination } from "services";
import { AuthenticationService } from "services/AuthenticationService";
import { BrokersService } from "services/BrokersService";
import { LoanService } from "services/LoanService";
import {
  AppFormikPasswordField,
  AppFormikTextField,
  AppPrimaryButton,
  AppSecondaryButton,
} from "shared/components/AppComponents";
import { RoleCode } from "shared/helpers/Constants";
import {
  brokerLoginValidationSchema,
  changePasswordValidationSchema,
  RegisterSchema,
} from "shared/helpers/Schema";
import Utils from "shared/helpers/Utils";
import { AuthActions } from "state/auth/Action";
import { ProfileActions } from "state/profile/Action";
import { ProgressActions } from "state/progress/Action";

const Brokers = () => {
  const { handleReviewDetails, handleUpdateUserLoan, getAllApplications } =
    useProgress();

  const [showMultipleLoans, setShowMultipleLoans] = useState(null);
  const [loaderMultiLoans, setLoaderMultiLoans] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  const [newLoanType, setNewLoanType] = useState(null);
  const [pagination] = useState({
    ...DefaultPagination(10),
  });

  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useIsMobile();
  const location = useLocation();
  const authInfo = useSelector((state: any) => state.authState);
  const profileState = useSelector((state: any) => state.profileState);
  const isSblApplyRoute = /^\/sbl(\/|$)/.test(location.pathname);
  const [defaultPassword, setDefaultPassword] = useState(false);
  const valuePath = isSblApplyRoute ? "sbl" : "rnd";
  const dispatch = useDispatch();

  const handleBrokerLogin = (formValues, formik) => {
    BrokersService.loginBroker(formValues)
      .then((response: any) => {
        let data = response.data.data;
        console.log(data);

        const handleToken = new Promise((resolve, reject) => {
          const brokerDetails = () => {
            if (data.isDefaultPassword) {
              return {
                firstName: data.firstName,
                lastName: data.lastName,
                isDefaultPassword: data.isDefaultPassword,
                loanCount: data.loanCount,
                currentPassword: formValues.password,
                userId: data.userId,
                email: data.email,
              };
            }
            return data;
          };

          dispatch(
            AuthActions.setAuthData({
              accessToken: data.accessToken,
              refreshToken: data.refreshToken,
              isUserLoggedIn: true,
              brokerDetails: brokerDetails(),
              userRole: RoleCode.BROKER,
            }),
          );

          resolve(true);
        });

        handleToken.then(() => {
          setDefaultPassword(data.isDefaultPassword);
        });

        Utils.handleSuccessResponse(response);
      })
      .catch((error: any) => {
        Utils.handleErrorResponse(error);
      })
      .finally(() => {
        formik.setSubmitting(false);
      });
  };

  const handleChangePassword = (formValues, formik) => {
    BrokersService.changePassword({
      currentPassword: authInfo.brokerDetails.currentPassword,
      newPassword: formValues.confirmNewPassword,
    })
      .then((response: any) => {
        dispatch(
          AuthActions.setAuthData({
            brokerDetails: {
              ...authInfo.brokerDetails,
              isDefaultPassword: false,
            },
          }),
        );

        Utils.handleSuccessResponse(response);
        // navigate("/");
        BrokersService.getBrokerDetails().then((res) => {
          console.log(res);
        });
      })
      .catch((error: any) => {
        Utils.handleErrorResponse(error);
      })
      .finally(() => {
        formik.setSubmitting(false);
      });
  };

  const updateUserProfile = (data) => {
    console.log(data);
    if (!data) return;
    let LoanType = getLoanTypeValue(data.loanType);

    const updateUserDeails = new Promise((resolve, reject) => {
      if (data.loanType === 0) {
        dispatch(
          ProfileActions.setSblProfile({
            email: data.email,
            isEmailVerified: data.isEmailVerified || false,
            loadId: data.loanId,
            userId: data.userId || "-",
            firstName: data.firstName || "-",
            lastName: data.lastName || "-",
            phoneNumber: data.phoneNumber
              ? data.phoneNumber.startsWith("+61 ")
                ? data.phoneNumber
                : data.phoneNumber.startsWith("+61")
                  ? "+61 " + data.phoneNumber.slice(3)
                  : data.phoneNumber
              : "-",
            isDocumentMappingCompleted: data.isDocumentMappingCompleted || "-",
            identityVerificationStatus: data.identityVerificationStatus || "-",
          }),
        );
        LoanService.getLoanReview(data.loanId)
          .then((response) => {
            handleUpdateUserLoan(response);
            handleReviewDetails(response);
          })
          .catch((error) => {
            Utils.handleErrorResponse(error);
          });
      }

      if (data.loanType === 1) {
        dispatch(
          ProfileActions.setRndProfile({
            email: data.email,
            isEmailVerified: data.isEmailVerified,
            loadId: data.loadId,
            userId: data.userId,
            firstName: data.firstName,
            lastName: data.lastName,
            phoneNumber: data.phoneNumber
              ? data.phoneNumber.startsWith("+61 ")
                ? data.phoneNumber
                : data.phoneNumber.startsWith("+61")
                  ? "+61 " + data.phoneNumber.slice(3)
                  : data.phoneNumber
              : "-",
            isDocumentMappingCompleted: data.isDocumentMappingCompleted,
            identityVerificationStatus: data.identityVerificationStatus,
          }),
        );
        LoanService.getRNDLoanReview(data.loadId)
          .then((response) => {
            handleUpdateUserLoan(response);
            handleReviewDetails(response);
          })
          .catch((error) => {
            Utils.handleErrorResponse(error);
          });
      }
      resolve(true);
    });

    updateUserDeails.then(() => {
      setShowMultipleLoans(null);
      setLoaderMultiLoans(false);
      dispatch(ProgressActions.switchLoanType(LoanType));
    });
  };

  const handleGettingToken = (data, callback) => {
    AuthenticationService.generateUserToken({
      email: data.email,
      loanType: data.loanType,
      loanId: data.loanId,
    })
      .then((response: any) => {
        callback(response.data.data);
      })
      .catch((error: any) => Utils.handleErrorResponse(error));
  };

  useEffect(() => {
    if (authInfo.selectedLoan) {
      const item = authInfo.rowLoanStatus.find(
        (r) => r.id === authInfo.selectedLoan,
      );

      try {
        navigate(`/${item.value}/intro-details`);
      } catch (e) {
        console.log(e);
      }
    }
  }, [authInfo.selectedLoan, location.pathname]);

  useEffect(() => {
    console.log(authInfo.brokerDetails);
    dispatch(ProfileActions.brokerAppDialog(null));
    setDefaultPassword(authInfo.brokerDetails?.isDefaultPassword);
    if (
      authInfo.brokerDetails &&
      !authInfo.brokerDetails.isDefaultPassword &&
      firstRender
    ) {
      // navigate("/");
      BrokersService.getBrokerDetails().then((res) => {
        const data = res.data.data;
        setFirstRender(false);

        if (data.userInfo.loanCount === 0) {
          dispatch(ProfileActions.brokerAppDialog(data.userInfo));
        } else {
          getAllApplications(
            pagination,
            data.userInfo.brokerId,
            (transformedRows) => {
              if (transformedRows.length > 0) {
                setShowMultipleLoans(transformedRows);
              }
            },
          );
        }
      });
    }
  }, [authInfo.brokerDetails]);

  return (
    <>
      {/* Choosing Loan Type */}
      <DialogBrokerApplications
        dialogCreateLoan={profileState.brokerAppDialog}
        setDialogCreateLoan={(value) => {
          dispatch(ProfileActions.brokerAppDialog(value));
        }}
        newLoanType={newLoanType}
        setNewLoanType={setNewLoanType}
        callbackCreate={(data) => {
          updateUserProfile({
            ...data,
            loanId: data.loanId,
            loadId: data.loanId,
            loanType: data.loanType,
          });
        }}
        getAllApplications={(brokerId) => {
          getAllApplications(pagination, brokerId, (transformedRows) => {
            if (transformedRows.length > 0) {
              setShowMultipleLoans(transformedRows);
            }
          });
        }}
      />

      <DialogMultipleLoans
        isOpen={showMultipleLoans}
        setIsOpen={setShowMultipleLoans}
        rowLoanStatus={showMultipleLoans}
        callback={(e) => {
          console.log(e);
          setLoaderMultiLoans(true);
          const multiLoans = new Promise((resolve, reject) => {
            dispatch(
              AuthActions.setAuthData({
                selectedLoan: e.id,
                hasMultipleLoans: true,
              }),
            );
            resolve(true);
          });
          multiLoans.then(() => {
            handleGettingToken(
              {
                email: e.email,
                loanType: e.loanActualType,
                loanId: e.id,
              },
              (e) => {
                const switchToken = new Promise((resolve, reject) => {
                  let LoanType = getLoanTypeValue(e.loanType);
                  dispatch(ProgressActions.switchLoanType(LoanType));

                  dispatch(
                    AuthActions.setAuthData({
                      accessToken: e.accessToken,
                      refreshToken: e.refreshToken,
                      selectedLoan: e.loanId,
                    }),
                  );

                  resolve(true);
                });
                switchToken.then(() => {
                  updateUserProfile({
                    ...e,
                    loadId: e.loanId,
                    loanType: e.loanType,
                  });
                });
              },
            );
          });
        }}
        loaderMultiLoans={loaderMultiLoans}
        createNewLoan={true}
        handleCreateNew={() => {
          dispatch(ProfileActions.brokerAppDialog(authInfo.brokerDetails));
        }}
      />

      <Grid container component="main" className="brokers-auth-wrapper">
        <Grid
          size={{ xs: 12, sm: 8, md: 7 }}
          component="div"
          sx={{
            [theme.breakpoints.down("md")]: {
              display: "none",
            },
          }}
        >
          <Box className="brokers-auth-full-background">
            <Box className="left-panel">
              <Box className="bg-image align-content-center flex-column">
                <img className="app-logo" src="/images/ezifin_logo.png" />
                <Typography variant="h1" className="title pt-3">
                  Ezifin Broker
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid
          size={{ xs: 12, sm: 4, md: 5 }}
          component="div"
          className="right-panel"
        >
          <Suspense fallback={<LinearProgress color="primary" />}>
            <Box className="login-form-wrapper">
              <Typography
                data-testid="login-title"
                className="title"
                variant="h2"
              >
                Login {isMobile && "Ezifin Broker"}
              </Typography>

              <Box mt={7}>
                {!authInfo.isUserLoggedIn && (
                  <Formik
                    enableReinitialize
                    validationSchema={brokerLoginValidationSchema}
                    validateOnMount
                    onSubmit={(formValues, formik) => {
                      handleBrokerLogin(formValues, formik);
                    }}
                    initialValues={{
                      email: null,
                      password: null,
                    }}
                  >
                    {({ handleSubmit, errors, isSubmitting }) => {
                      console.log(errors);
                      return (
                        <form autoComplete="off">
                          <Box mt={3}>
                            <AppFormikTextField
                              placeholder="Email"
                              label="Email"
                              name="email"
                              outerLabel
                              className="ezifin-default-field"
                            />
                          </Box>

                          <Box mt={3}>
                            <AppFormikPasswordField
                              placeholder="Password"
                              label="Password"
                              name="password"
                              outerLabel
                              className="ezifin-default-field"
                            />
                          </Box>

                          <Box mt={3}>
                            <AppPrimaryButton
                              title="Login"
                              isLoading={isSubmitting}
                              loadingText="Please wait.."
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleSubmit();
                              }}
                              disabled={
                                Object.keys(errors).length > 0 || isSubmitting
                              }
                            />
                          </Box>
                        </form>
                      );
                    }}
                  </Formik>
                )}

                {authInfo.isUserLoggedIn &&
                  !authInfo.selectedLoan &&
                  defaultPassword && (
                    <>
                      <Typography variant="h3" fontWeight={400}>
                        Hi{" "}
                        <b>
                          {authInfo.brokerDetails.firstName}{" "}
                          {authInfo.brokerDetails.lastName}.
                        </b>{" "}
                        Before continuing, please change your password!
                      </Typography>
                      <Formik
                        enableReinitialize
                        validationSchema={changePasswordValidationSchema}
                        validateOnMount
                        onSubmit={(formValues, formik) => {
                          handleChangePassword(formValues, formik);
                        }}
                        initialValues={{
                          newPassword: null,
                          confirmNewPassword: null,
                        }}
                      >
                        {({
                          handleSubmit,
                          errors,
                          isSubmitting,
                          dirty,
                          values,
                        }) => {
                          console.log(errors);
                          return (
                            <form autoComplete="off">
                              <Box mt={3}>
                                <AppFormikPasswordField
                                  placeholder="New password"
                                  label="New password"
                                  name="newPassword"
                                  outerLabel
                                  className="ezifin-default-field"
                                />
                              </Box>
                              <Box mt={3}>
                                <AppFormikPasswordField
                                  placeholder="Confirm new password"
                                  label="Confirm new password"
                                  name="confirmNewPassword"
                                  outerLabel
                                  className="ezifin-default-field"
                                />
                              </Box>

                              <Box mt={3}>
                                <AppPrimaryButton
                                  title="Submit"
                                  isLoading={isSubmitting}
                                  loadingText="Please wait.."
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleSubmit();
                                  }}
                                  disabled={
                                    Object.keys(errors).length > 0 ||
                                    isSubmitting ||
                                    !dirty
                                  }
                                />
                              </Box>
                            </form>
                          );
                        }}
                      </Formik>
                    </>
                  )}
              </Box>
            </Box>
          </Suspense>
        </Grid>
      </Grid>
    </>
  );
};

export default Brokers;
